@if (isAnimation()) {
<div class="hp-text animated" [class.reverse]="isChallenger()">
  <span class="typography-small">{{ animatedHp() | number : "1.0-0" }}</span>
  <span
    class="typography-small"
    [class.hp-text_active]="user().initial_hp !== animatedHp()"
  >
    / {{ user().initial_hp | number : "1.0-0" }} HP
  </span>
</div>
} @else {
<div class="hp-text default" [class.reverse]="isChallenger()">
  <span class="typography-small">{{ user().hp | number : "1.0-0" }}</span>
  <span
    class="typography-small"
    [class.hp-text_active]="user().initial_hp !== user().hp"
  >
    / {{ user().initial_hp | number : "1.0-0" }} HP
  </span>
</div>
}
<div class="wrapper" [class.reverse]="isChallenger()" #hpBar>
  <div
    class="slider"
    [style.width.%]="
      ((user().hp! < 0 ? 0 : user().hp!) / user().initial_hp!) * 100
    "
  ></div>
</div>
